/* eslint-disable */
import React from 'react';
import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';

const ProtectedRouteMain = ({ element }) => {
  const token = Cookies.get('sc_authToken');
  
  if (token) {
    const urlParams = new URLSearchParams(window.location.search);
    const contentParam = urlParams.get('content');
    localStorage.setItem('content', contentParam);
    if (contentParam) {
      window.location.href = `${process.env.REACT_APP_MAIN_URL}/dashboard/ai-agents/agent?content=${contentParam}`;
    } else {
      window.location.href = `${process.env.REACT_APP_MAIN_URL}/login`;
    }
    return null;
  }
  return element;
};

export default ProtectedRouteMain; 
